import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import {
	FormControl,
	FormHelperText,
	InputAdornment,
	InputLabel,
	OutlinedInput,
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import type React from "react";

const theme = createTheme({
	components: {
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					borderRadius: "12px",
					".MuiOutlinedInput-notchedOutline": {
						borderColor: "#71717A",
					},
					"&:hover .MuiOutlinedInput-notchedOutline": {
						borderColor: "#71717A",
					},
					"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
						borderColor: "#71717A",
					},
					"&.Mui-error .MuiOutlinedInput-notchedOutline": {
						borderColor: "#DC2626",
					},
				},
				input: {
					color: "#3F3F46",
				},
				notchedOutline: {
					"& legend > span": {
						display: "none",
					},
				},
			},
		},
		MuiInputLabel: {
			styleOverrides: {
				root: {
					maxWidth: "310px",
					fontFamily: "Montserrat",
					fontSize: "16px",
					textWrap: "pretty",
					color: "#3F3F46",
					backgroundColor: "#FFFFFF",
					padding: "4px",
					transform: "translate(45px, 12px) scale(1)", // Default position
					transition: "transform 200ms ease-in-out",
					"&.Mui-focused": {
						color: "#3F3F46",
						textWrap: "nowrap",
						top: 0,
						maxWidth: "100%",
						transform: "translate(12px, -10px) scale(0.75)", // Focused position
					},
					"&.MuiFormLabel-filled": {
						textWrap: "nowrap",
						top: 0,
						maxWidth: "100%",
						transform: "translate(12px, -10px) scale(0.75)", // Filled position
					},
					"&.Mui-error": {
						color: "#DC2626",
					},
				},
			},
		},
		MuiInputAdornment: {
			styleOverrides: {
				root: {
					fontSize: "24px",
					color: "#3F3F46",
				},
			},
		},
		MuiFormHelperText: {
			styleOverrides: {
				root: {
					fontFamily: "Montserrat",
					"&.Mui-error": {
						color: "#DC2626",
					},
				},
			},
		},
	},
});

type Props = {
	type?: string;
	value: string;
	errorMessage?: string;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const EmailInput: React.FC<Props> = ({
	type = "text",
	value,
	errorMessage,
	onChange,
}) => {
	return (
		<ThemeProvider theme={theme}>
			<FormControl
				fullWidth
				sx={{ marginBottom: errorMessage ? "20px" : "0", height: "56px" }}
				variant="outlined"
				error={!!errorMessage}
			>
				<InputLabel htmlFor="email-input" shrink>
					{"Email"}
				</InputLabel>
				<OutlinedInput
					id="email-input"
					type={type}
					value={value}
					name="email-input"
					onChange={onChange}
					startAdornment={
						<InputAdornment position="start">
							<MailOutlineIcon />
						</InputAdornment>
					}
					endAdornment={
						errorMessage && (
							<InputAdornment position="end">
								<ErrorRoundedIcon sx={{ color: "#DC2626" }} />
							</InputAdornment>
						)
					}
					label={"Email"}
				/>
				{errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
			</FormControl>
		</ThemeProvider>
	);
};

export default EmailInput;
